import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

//modules
import auth from './modules/auth'
import layout from './modules/layout'
import chat from './modules/chat'
import chatAuthor from './modules/chatAuthor'
import support from './modules/support'
import calendar from "@/store/modules/calendar";
import notifications from "@/store/modules/notifications";
import website from './modules/website'

Vue.use(Vuex)

export default new Vuex.Store({
	getters,
	mutations,
	state,
	actions,
	strict: process.env.NODE_ENV !== 'production',
	modules: {
		auth,
		layout,
		chat,
		chatAuthor,
		support,
		calendar,
		notifications,
		website,
	}
})
